import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Opdaterer kurven, når Dealeasy selv har ændret den.
 *
 * Dealeasy lægger gaven (vaskeposen ved 9 par) i kurven via sit eget kald til
 * /cart/add.js og sender derefter `lb-dealeasy-manual-cart-refresh` på window.
 * Selve opdateringen af temaet kender kun Dawn- og Impact-lignende temaer, så
 * Horizons drawer og kurv-ikon viser den gamle kurv, indtil næste ændring.
 *
 * Her sendes samme event som product-form.js. Uden `sections` renderer
 * cart-items-component sin sektion forfra, og cart-icon opdaterer tallet.
 * Lytteren sidder på modulniveau, så den virker, selvom draweren var tom, da
 * siden blev loadet.
 */
async function onDealeasyRefresh() {
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'update',
      context: 'cart',
      lines: [],
      promise: deferred.promise,
    })
  );

  try {
    const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'locktown-dealeasy-sync',
        itemCount: cart.item_count,
        didError: false,
      },
    });
  } catch (error) {
    console.warn('[locktown-dealeasy-sync]', error);
    deferred.reject(error);
  }
}

window.addEventListener('lb-dealeasy-manual-cart-refresh', onDealeasyRefresh);
